// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-text[data-v-279cc7a5] {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0.8rem;\n  padding: 0 0.8rem;\n  overflow: hidden;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-size: 0.85333rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
